import React from "react";
import {Button, Tooltip, Upload} from "antd";
import {ArrowDownOutlined, ArrowUpOutlined, CloseOutlined, InboxOutlined} from "@ant-design/icons";

const MultiFileUploader = ({
                               fileList = [],
                               onUpload,
                               onChange,
                               onRemove,
                               onReorder,
                               label,
                               accept = ".pdf,image/*",
                               maxCount,
                               multiple = true,
                               disabled = false,
                           }) => {
    return (
        <div className="flex flex-col w-full">
            {label && (
                <label className="text-sm text-[#0B1220] mb-2 font-medium">{label}</label>
            )}

            {fileList?.length > 0 && (
                <div className="flex flex-col gap-2 mb-3">
                    {fileList.map((file, index) => (
                        <div
                            key={file.uid}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                padding: "10px 12px",
                                background: "#fff",
                                border: "1px solid #E4E7EE",
                                borderRadius: 10,
                            }}
                        >
                            <div
                                style={{
                                    width: 24,
                                    height: 24,
                                    borderRadius: 6,
                                    background: "#F1F3F7",
                                    color: "#55607A",
                                    display: "grid",
                                    placeItems: "center",
                                    fontWeight: 600,
                                    fontSize: 11,
                                    flexShrink: 0,
                                }}
                            >
                                {index + 1}
                            </div>
                            <div
                                style={{
                                    flex: 1,
                                    minWidth: 0,
                                    fontSize: 13,
                                    color: "#0B1220",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {file.name}
                            </div>
                            <Tooltip title="Move up">
                                <Button
                                    size="small"
                                    type="text"
                                    icon={<ArrowUpOutlined/>}
                                    disabled={index === 0}
                                    onClick={() => onReorder?.(index, index - 1)}
                                />
                            </Tooltip>
                            <Tooltip title="Move down">
                                <Button
                                    size="small"
                                    type="text"
                                    icon={<ArrowDownOutlined/>}
                                    disabled={index === fileList.length - 1}
                                    onClick={() => onReorder?.(index, index + 1)}
                                />
                            </Tooltip>
                            <Tooltip title="Remove">
                                <Button
                                    size="small"
                                    type="text"
                                    danger
                                    icon={<CloseOutlined/>}
                                    onClick={() => onRemove?.(file)}
                                />
                            </Tooltip>
                        </div>
                    ))}
                </div>
            )}

            <Upload
                multiple={multiple}
                disabled={disabled}
                className="w-full"
                accept={accept}
                fileList={fileList}
                customRequest={onUpload}
                onChange={({file, fileList: nextList}) => onChange?.(file, nextList)}
                onRemove={onRemove}
                showUploadList={false}
                maxCount={maxCount}
            >
                <div
                    style={{
                        border: "1.5px dashed #CFD4DF",
                        borderRadius: 10,
                        padding: "18px",
                        textAlign: "center",
                        color: "#7A849A",
                        fontSize: 13,
                        cursor: disabled ? "not-allowed" : "pointer",
                        opacity: disabled ? 0.6 : 1,
                        background: "#FAFBFE",
                    }}
                >
                    <InboxOutlined style={{fontSize: 22, color: "#7A849A", marginRight: 8}}/>
                    Drag &amp; drop files here, or click to browse
                    {maxCount && (
                        <span style={{marginLeft: 8, color: "#A0A8B8", fontSize: 12}}>(max {maxCount})</span>
                    )}
                </div>
            </Upload>
        </div>
    );
};

export default MultiFileUploader;
